var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-primary-frame"},[_c('m-domains-detail')],1),_vm._v(" "),_c('div',{staticClass:"m-secondary-frame"},[_c('m-secondary-account')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }